import { render } from "./memberIntroduction.vue?vue&type=template&id=6a11ad6c&scoped=true"
import script from "./memberIntroduction.vue?vue&type=script&lang=js"
export * from "./memberIntroduction.vue?vue&type=script&lang=js"

import "./memberIntroduction.vue?vue&type=style&index=0&id=6a11ad6c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a11ad6c"]])

export default __exports__